<template>
    <div>

        <div class="proj-toolbox-area">
            <h4 v-text="$t('menu.participants') + ' ' + $t('menu.management')"></h4>

            <div class="proj-toolbox-body text-left">
                {{ $t('menu.add_project_member') }}
                <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text><i class="cui-envelope-closed"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input id="input_email" type="email" class="form-control"
                                v-model.trim="email" autocomplete="email"
                                :placeholder="$t('menu.email')" :state="checkEmail" />
                </b-input-group>
                <!-- Admin 可以有相關搜尋 -->
                <div v-if="user_admin">
                    <div v-if="list_search_matched_users.length > 0" class="list-search-area">
                        <div class="list-search-area-title">[ {{ $t('menu.related_search') }} ] 尚未加入專案的使用者：</div>
                        
                        <div class="list-search-area-result grab-bing scroll-style-gray" v-dragscroll>
                            <div v-for="(match,idx_mat) in list_search_matched_users" :key="idx_mat"
                                class="list-search-area-button"
                                @click="email = match.email">
                                {{ match.searchValue }}
                                <div class="list-search-area-hover">
                                    <i class="fa fa-plus-circle"></i>select
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <b-input-group>
                    <b-select v-model="add_role" class="select-role">
                        <option v-for="(role, idx_r) in object_all_roles" :key="idx_r" :value="role.name" class="select-option">
                            <div v-html="role.html"></div>
                        </option>
                    </b-select>
                    <b-button variant="success" @click="addMember" :disabled="checkAddBTNDisabled"><i class="fa fa-plus"></i></b-button>
                </b-input-group>
            </div>               
            
            <hr>

            <div class="proj-toolbox-body text-left">
                {{ $t('menu.project') }} {{ $t('menu.participants') }}
                <b-badge class="badge-small">{{ list_proj_members.length }}</b-badge>
                <b-button :variant="(btn_show_member_detail ? '': 'outlint-') + 'dark'"
                        class="btn-show-toggle"
                        @click=" btn_show_member_detail = ! btn_show_member_detail ">
                        <i class="fa fa-reorder"></i> {{ $t('menu.show_detail') }}
                </b-button>

                <div class="list-edit-area-result grab-bing scroll-style-gray" v-dragscroll>
                    
                        <template v-for="(member, idx_m) in list_proj_members">
                            <div :key="idx_m">
        
                                <div class="list-edit-area-button" @click="edit_confirm(member)">
                                    {{ member.first_name }} {{ member.last_name }}
                                    <b-badge variant="warning" class="block-text"><i :class="$tools.style.classRoleIcon(member.role)"></i>{{ member.role }}</b-badge> 
                                    <b-badge v-if="member.is_admin && user_admin" variant="danger" class="block-text">admin</b-badge>

                                
                                    <div class="list-edit-area-hover">
                                        <i class="fa fa-pencil-square"></i>edit
                                    </div>
                                </div>

                                <div v-if ="btn_show_member_detail" class="list-edit-area-toggle-context">
                                    User ID：{{ member.id }}<br>
                                    Email：{{ member.email }}<br>
                                    Role：{{ $t('n.' + member.role ) }}
                                </div>

                            </div>
                        </template>
                        
                </div>

            </div>
        
        </div>

        <!-- Modal: confirm delete -->
        <b-modal v-model="confirm_show_modal" :title="conform_title" header-bg-variant="primary" hide-header-close hide-footer>
            
            <div class="list-edit-area-modal-body">
                <h4>{{ $t('menu.editting') }} {{ $t('menu.project') }} {{ $t('menu.role') }}</h4>
                <b-button-group>
                    <b-select v-model="add_role" class="select-role">
                        <option v-for="(role, idx_r) in object_all_roles" :key="idx_r" :value="role.name" class="select-option">
                            <div v-html="role.html"></div>
                        </option>
                    </b-select>
                </b-button-group>
            </div>

            <div class="list-edit-area-modal-body">
                <h4>{{ $t('other.enter_confirmation_code') }}：{{ confirm_text }}</h4>
                <b-form-input type="text" :placeholder="$t('other.enter_confirmation_code')" v-model="confirm_answer"></b-form-input>
            </div>

            <div class="text-center">

                <b-button variant="dark" class="px-4 btn-upload"
                        @click="remove_member(confirm_target)"
                        :disabled="confirm_text != confirm_answer">
                        {{ $t('menu.remove') }}
                        <!-- 從專案移除該使用者 -->
                </b-button>

                <button type="button" class="btn btn-secondary btn-upload" @click.prevent="confirm_show_modal = false" :disabled="uploading">
                    <i class="fa fa-close"></i> {{ $t('menu.cancel') }}
                </button>

                <b-button variant="danger" class="px-4 btn-upload"
                        @click="update_member(confirm_target)"
                        :disabled="confirm_text != confirm_answer">
                        {{ $t('menu.save_changes') }}
                </b-button>

                
            </div>
        </b-modal>

    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import { dragscroll } from 'vue-dragscroll'             // 滑鼠可拖拉 scroll 區域

export default {
    props: {
        projectID: {
            type: [String, Number],
            required: true,
        },
    },
    directives: {
        'dragscroll': dragscroll,
    },
    data () {
        return {
            user_role: 'project_owner',

            list_all_users: [],
            list_all_roles: [],
            object_all_roles: {},
            list_proj_members: [],
            email: '',
            add_role: 'project_member',

            btn_show_member_detail: false,

            uploading: false,

            // confirm
            confirm_show_modal: false,
            conform_title: '',
            confirm_text: '',
            confirm_answer: '',
            confirm_target: undefined,
        }
    },
    mounted () {
        this.getProjectRoles();
    },
    computed: {
        ...mapState({
            'language': state => state.user.language,
            'user_admin': state => state.user.is_admin,
            'user_email': state => state.user.email,
            'project_detail': state => state.project.project_detail,
        }),
    
        checkEmail ()
        {
            return this.$tools.input.checkEmail(this.email)
        },

        checkAddBTNDisabled ()
        {
            if (this.email == '')        return true;
            if (this.email == undefined) return true;
            if (this.checkEmail == false) return true;
            return false;
        },

        list_search_matched_users ()
        {
            let _matched = []
            if (this.email != '')
            {
                this.list_all_users.forEach( _user => {
                    
                    if ( _user.searchValue.indexOf( this.email ) !== -1 )
                    {
                        _matched.push( _user )
                    }
                })
            }
            return _matched
        },
    },
    watch: {
        user_admin: function (newVal, oldVal)
        {
            if (newVal == true)
            {
                this.getAllUsers();
            }
        },

        language: function (newVal, oldVal)
        {
            this.getObjectAllRoles()
        },
    },
    methods: {

        getMemberRole (email, members)
        {
            let _role = 'project_owner'
            members.forEach( _member => {
                if ( _member['email'] == email )
                {
                    _role = _member.role
                }
            })
            return _role
        },

        checkMemberExist (identity, identityType = 'email')
        {
            let _exist = false
            this.list_proj_members.forEach( _member => {
                if ( _member[ identityType ] == identity )
                {
                    _exist = true
                }
            })
            return _exist
        },

        addMember ()
        {
            if ( this.user_admin && this.checkMemberExist(this.email) )
            {
                alert('使用者已在此專案中！')
            }
            else
            {
                this.uploading = true;
                const options = {
                    method: 'POST',
                    url: this.$config.getAPI_URL('Project_Edit_Members', { projectID: this.projectID }),
                    data: {
                        user_email: this.email,
                        role_id: this.object_all_roles[ this.add_role ].id,
                    },
                }
                this.$http(options)
                    .then(res => {
                        this.getProjectMembers();
                        this.uploading = false;
                        this.$toastr.s( this.$t('other.update_succeeded'), this.$t('menu.project') + ' ' + this.$t('menu.participants') + ': ' + this.email );
                        this.email = '';
            
                    })
                    .catch(err => {
                        this.uploading = false;
                        this.$toastr.e( this.$t('other.update_failed'), this.$t('menu.project') + ' ' + this.$t('menu.participants') + ': ' + this.email );
                    })
                
                // 送出使用者操作紀錄 --------------------
                let _OPLog = {
                    user_id: this.$store.state.user.id,
                    type: 'write',
                    detail: {
                        page: 'project',
                        action: 'add member',
                        querySettings: {
                            'project ID':     this.projID,
                            'project name':   this.project_detail.name,
                            'member email':   options.data.user_email,
                            'member role':    this.add_role,
                        },
                        pageInfo: {
                            'is admin':       this.user_admin,
                            'user role':      this.project_detail.role,
                            'project status': this.project_detail.status,
                            'service level':  this.project_detail.service_level,
                        },
                    },
                }
                this.$store.dispatch('user/createLog', _OPLog).then( res => {}).catch( err => {})
                // 送出使用者操作紀錄 --------------------
            }
        },

        getProjectRoles ()
        {
            const options = {
                method: 'GET',
                url: this.$config.getAPI_URL('Project_Show_Roles', {}),
            }
            this.$http(options)
                .then(res => {
                    this.list_all_roles = res.data.roles;
                    
                    this.getProjectMembers();
                    
                })
                .catch(err => {
                })
        },

        getProjectMembers ()
        {
            const options = {
                method: 'GET',
                url: this.$config.getAPI_URL('Project_Show_Members', { projectID: this.projectID }),
            }
            this.$http(options)
                .then(res => {

                    let _all_members = res.data.members
                    this.user_role = this.getMemberRole( this.user_email, _all_members ); // 取得使用者身分

                    /// 處理要顯示的成員
                    // admin 或 beehive 身分才看的到全部的成員
                    if (this.user_admin || this.user_role == 'beehive')
                    {
                        this.list_proj_members = _all_members
                        if (this.user_admin) this.getAllUsers(); // 目前取得所有使用者的 API 只有 admin 才可以使用
                    }
                    else
                    {
                        this.list_proj_members = []
                        res.data.members.forEach( _member => {
                            if (_member.role != 'beehive')
                            {
                                this.list_proj_members.push( _member );
                            }
                        })
                    }

                    this.getObjectAllRoles()
                    
                    
                })
                .catch(err => {
                })
        },

        getObjectAllRoles ()
        {
            /// 處理要顯示的身分
            this.list_all_roles.forEach( _role => {

                // 如果不是 admin 或 beehive 身分，就不顯示 beehive 選項
                if ( this.user_admin == false && this.user_role != 'beehive' && _role.name == 'beehive' )
                {
                    // Don't add 'beehive' role to list
                }
                else
                {
                    this.object_all_roles[ _role.name ] = {
                        id: _role.id,
                        name: _role.name,
                        description: _role.description,
                        value: _role.id,
                        html: `<i class="${ this.$tools.style.classRoleIcon(_role.name) }"></i>${ this.$t('n.' + _role.name) }`,
                    };
                }
            });
        },

        getAllUsers ()
        {
            const options = {
                method: 'GET',
                url: this.$config.getAPI_URL('List_User', {}), // 列出非admin的所有使用者
            }
            this.$http(options)
                .then(res => {
                    this.list_all_users = res.data.users
                    this.list_all_users.forEach( _user => {

                        // 排除已經是專案成員的使用者
                        let _isMember = false
                        this.list_proj_members.forEach( _member => {

                            if (_member.id == _user.id) { _isMember = true; }
                        })

                        if ( _isMember == false )
                        {
                            _user.searchValue = _user.first_name + ' ' + _user.last_name + ' ' + _user.email + ' '
                        }
                        else
                        {
                            _user.searchValue = '';
                        }
                    })
                })
                .catch(err => {
                })
        },


        modal_init (target)
        {
            this.confirm_show_modal = false;
            this.confirm_text = this.$tools.input.randomCode();
            this.confirm_answer = '';
            this.confirm_target = target;
            if (target)
            {
                this.add_role = target.role;
                this.conform_title = `${ this.$t('menu.editting') } ${ this.$t('menu.participants') }：${ target.first_name } ${ target.last_name }`;
            }
        },
        edit_confirm (target)
        {
            this.modal_init(target);
            this.confirm_show_modal = true;
        },
        // 從專案移除成員
        remove_member (target)
        {
            this.confirm_show_modal = false;
            this.uploading = true;
            
            let _userInfo = '<br>' + target.first_name + ' ' + target.last_name + ' (' + target.role + ')<br>' + target.email;
            const options = {
                method:'DELETE',
                url: this.$config.getAPI_URL('Project_Edit_Members', { projectID: this.projectID }),
                data: {
                    user_email: target.email,
                    role_id: this.object_all_roles[ target.role ].id,
                },
            }
            this.$http(options)
            .then( res => {
                this.getProjectMembers();
                this.uploading = false;
                this.$toastr.s( this.$t('other.update_succeeded'), this.$t('menu.project') + ' ' + this.$t('menu.participants') );
            })
            .catch( err => {
                // console.log(err);
                this.getProjectMembers();
                this.uploading = false;
                this.$toastr.e( this.$t('other.update_failed'), this.$t('menu.project') + ' ' + this.$t('menu.participants') );
            })
            
            // 送出使用者操作紀錄 --------------------
            let _OPLog = {
                user_id: this.$store.state.user.id,
                type: 'write',
                detail: {
                    page: 'project',
                    action: 'remove member',
                    querySettings: {
                        'project ID':     this.projID,
                        'project name':   this.project_detail.name,
                        'member email':   target.email,
                        'member name':    target.first_name + ' ' + target.last_name,
                        'member role':    target.role,
                    },
                    pageInfo: {
                        'is admin':       this.user_admin,
                        'user role':      this.project_detail.role,
                        'project status': this.project_detail.status,
                        'service level':  this.project_detail.service_level,
                    },
                },
            }
            this.$store.dispatch('user/createLog', _OPLog).then( res => {}).catch( err => {})
            // 送出使用者操作紀錄 --------------------
        },
        // 更新專案成員身分
        update_member (target)
        {
            this.confirm_show_modal = false;
            this.uploading = true;
            
            let _userInfo = '<br>' + target.first_name + ' ' + target.last_name + '<br>( ' + target.role + ' => ' + this.add_role + ' )<br>' + target.email;
            const options = {
                method:'PUT',
                url: this.$config.getAPI_URL('Project_Edit_Members', { projectID: this.projectID }),
                data: {
                    user_email: target.email,
                    role_id: this.object_all_roles[ target.role ].id,
                    new_role_id: this.object_all_roles[ this.add_role ].id,
                },
            }
            this.$http(options)
            .then( res => {
                this.getProjectMembers();
                this.uploading = false;
                this.$toastr.s( this.$t('other.update_succeeded'),
                                this.$t('menu.project') + ' ' + this.$t('menu.participants') + ': ' + target.email + '<br>'
                                + this.$t('n.' + target.role) + ' => ' + this.$t('n.' + this.add_role) );
            })
            .catch( err => {
                // console.log(err);
                this.getProjectMembers();
                this.uploading = false;
                this.$toastr.e( this.$t('other.update_failed'),
                                this.$t('menu.project') + ' ' + this.$t('menu.participants') + ': ' + target.email + '<br>'
                                + this.$t('n.' + target.role) + ' => ' + this.$t('n.' + this.add_role) );
            })
            
            // 送出使用者操作紀錄 --------------------
            let _OPLog = {
                user_id: this.$store.state.user.id,
                type: 'write',
                detail: {
                    page: 'project',
                    action: 'update member',
                    querySettings: {
                        'project ID':       this.projID,
                        'project name':     this.project_detail.name,
                        'member email':     target.email,
                        'member name':      target.first_name + ' ' + target.last_name,
                        'member role change': target.role + ' => ' + this.add_role,
                    },
                    pageInfo: {
                        'is admin':       this.user_admin,
                        'user role':      this.project_detail.role,
                        'project status': this.project_detail.status,
                        'service level':  this.project_detail.service_level,
                    },
                },
            }
            this.$store.dispatch('user/createLog', _OPLog).then( res => {}).catch( err => {})
            // 送出使用者操作紀錄 --------------------
        },

    },
}
</script>

<style lang="scss" scoped>

</style>
